export enum DocType {
    Unknown,
    Image,
    Pdf,
    Vimeo
}


// WEBPACK FOOTER //
// ./enums/DocType.ts